import { envConfig } from '@root/env';
import { Get, Post } from '@/service/request/server';
import { EnumContentType } from '@/constant/enums';

const baseUrl = envConfig.formalServer + '/plat/admin/functions/';
const systemBaseUrl = envConfig.formalServer + '/function/v1/';

function baseApi() {

    function insertCloudFunction(data) {
        return Post(baseUrl + `insertCloudFunction`, data);
    }

    function updateFunctionScript(data) {
        return Post(baseUrl + `updateFunctionScript`, data, {
            headers: {
                'Content-Type': EnumContentType.formData
            }
        });
    }

    function deployFunction(data) {
        return Post(baseUrl + `deployFunction`, data);
    }

    function deleteCloudFunction(data) {
        return Post(baseUrl + 'deleteCloudFunction', data);
    }

    function updateCloudFunction(data) {
        return Post(baseUrl + 'updateCloudFunction', data);
    }

    function listScriptFiles(data) {
        return Post(baseUrl + 'listScriptFiles', data);
    }

    function readFileContent(filePathList) {
        return Post(baseUrl + 'readFileContent', filePathList);
    }

    function queryCloudFunctionVersionList(data) {
        return Post(baseUrl + 'queryCloudFunctionVersionList', data);
    }

    function queryCloudFunctionList(data) {
        return Post(baseUrl + 'queryCloudFunction', data);
    }

    const system = {
        executeFunction: (name, projectName, isTestMode, data) => {
            return Post(systemBaseUrl + `functions/run/${name}`, data, {
                headers: {
                    'Test-Mode': isTestMode,
                    'Project-Name': projectName
                }
            });
        },
        getFunctionInfo: (name, projectName, isTestMode) => {
            return Get(systemBaseUrl + `functions/admin/info/{name}/${name}`, undefined, {
                headers: {
                    'Test-Mode': isTestMode,
                    'Project-Name': projectName
                }
            });
        },
        updateFunctionVersion: (name, projectName, isTestMode, instance) => {
            return Post(systemBaseUrl + `admin/update/update/function?metricsExporterTarget=${instance}`, {
                projectName: projectName,
                functionName: name,
                testMode: isTestMode
            }, {
                headers: {
                    'Project-Name': projectName
                }
            });
        },
        updateProjectCommonFunction: (projectName, isTestMode, instance) => {
            return Post(systemBaseUrl + `admin/update/update/common?metricsExporterTarget=${instance}`, {
                projectName: projectName,
                testMode: isTestMode
            }, {
                headers: {
                    'Test-Mode': isTestMode,
                    'Project-Name': projectName
                }
            });
        }
    };

    return {
        insertCloudFunction,
        updateFunctionScript,
        deployFunction,
        deleteCloudFunction,
        updateCloudFunction,
        listScriptFiles,
        readFileContent,
        queryCloudFunctionList,
        queryCloudFunctionVersionList,
        system
    };
}

export const cloudFunctionApi = baseApi();